module.exports = __webpack_public_path__ + "img/cow.55feeec4.png";